/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactcasebrieftimesaved4Inputs */

const en_artifactcasebrieftimesaved4 = /** @type {(inputs: Artifactcasebrieftimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves ~3 hrs reading CC arts. 1207–1230 and matching them to your facts`)
};

const pt_artifactcasebrieftimesaved4 = /** @type {(inputs: Artifactcasebrieftimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa ~3 horas a ler os arts. 1207.º–1230.º do CC e a cruzá-los com os seus factos`)
};

/**
* | output |
* | --- |
* | "Saves ~3 hrs reading CC arts. 1207–1230 and matching them to your facts" |
*
* @param {Artifactcasebrieftimesaved4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactcasebrieftimesaved4 = /** @type {((inputs?: Artifactcasebrieftimesaved4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactcasebrieftimesaved4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactcasebrieftimesaved4(inputs)
	return pt_artifactcasebrieftimesaved4(inputs)
});
export { artifactcasebrieftimesaved4 as "artifactCaseBriefTimeSaved" }